export default {
    'UsedTime': 'Used time:{time}',
    'FlowTrack': 'Workflow track',
    'Participant': 'Current Approver',
    'Participants': 'Current Approvers:',
    'FinishNode': 'Ended Activities',
    'ProcessNode': 'Processing Activities',
    'WrongNode': 'Unusual Activity',
    'UnstartNode': 'Unstarted Activity',
    'Person': '{length} person',
    'chartTips': 'Flowchart can be resized by gesture',
    'WorkflowActionStatus': {
        'Submit': 'Submit',
        'Submits': 'Submit',
        'Cancel': 'Cancel',
        'Agree': 'Agree',
        'DisAgree': 'Disagree',
        'AdjustParticipant': 'Add-approver',
        'Assist': 'Assist',
        'Forward': 'Transfer',
        'Reject': 'Reject',
        'FinishInstance': 'End-workflow',
        'UnRead': 'Unread',
        'Read': 'Read',
        'Empty': '',
        'Revoke': 'Revoke',
        'BeCanceled': 'Be Canceled',
    },
    'WorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Draft': 'Draft',
        'BeCanceled': 'Be Canceled',
    },
};
